<template>
  <base-section id="we-help-your-success">
    <base-section-heading
      title="WHO ARE WE"
      icon="mdi-account-outline"
      outlined
    >
      We are on a mission to bring blockchain to the real world.
    </base-section-heading>

    <v-container>
      <v-row justify="center">
        <v-col
          v-for="t in theTeam"
          :key="t.name"
          cols="9"
          md="3"
        >
          <v-hover>
            <template v-slot="{ hover }">
              <base-img
                :height="$vuetify.breakpoint.mdAndUp ? 400 : 400"
                :src="require(`@/assets/team/${t.teamMember.image}`)"
                color="grey lighten-1"
                flat
                tile
              >
                <v-overlay
                  :value="hover"
                  absolute
                  class="pa-6"
                  color="secondary"
                  opacity=".9"
                >
                  <base-subheading :title="`${t.teamMember.name}`" />

                  <base-body>
                    {{ t.teamMember.description }}
                  </base-body>
                </v-overlay>
              </base-img>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionWeHelpYourSuccess',
    data () {
      return {
        theTeam: [
          {
            teamMember: {
              name: 'JD Hammons',
              description: 'Finance, Mortgage, Real Estate, and Crypto',
              image: 'jd-hammons.jpg',
            },
          },
          {
            teamMember: {
              name: 'Trevor Walker',
              description: 'Architect - Software, Systems, Network, and Blockchain',
              image: 'trevor-walker.jpeg',
            },
          },
          {
            teamMember: {
              name: 'Chase Mortensen',
              description: 'Designer - Software, Usability, and Blockchain',
              image: 'chase-mortensen.jpg',
            },
          },
        ],
      }
    },
  }
</script>
